import React, { useEffect, useRef, useState } from 'react'
import Tools from '../../../../cvp-webgames-core/Misc/Tools';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { AnimationState } from '../../../../cvp-webgames-core/UI/Animation/animation-base';
import { AnimationPage } from '../../../../cvp-webgames-core/UI/Animation/animation-page';
import { constants } from '../../../../misc/constants';
import { BaseConfig } from '../../../BaseConfig';
import PopUp4 from '../../../general/pop-up4';

import "./accessibility-window.css"
import { CustomGameDataConfig, CustomGameDataManager, setFocus, TextHtmlTagType } from '../../../../misc/tools';

class AccessibilityWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'visibility',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/visibility.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'volume',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/audio-on.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'cc',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/closed-captioning-on.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'motion',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/motion.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'animations',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/animations.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'return1',
				src: process.env.PUBLIC_URL + '/assets/images/return1.svg'
			},
		];
	}
}

export const accessibilityWindowCaching = new AccessibilityWindowCaching();

let addOnColorSchemeChangedHandler : any = null;

const AccessibilityWindow = (props: AccessibilityWindowConfig) => {
	
	const [isDarkTheme, setIsDarkTheme] = useState(Tools.isUsingDarkMode());
	const [isForceUpdate, setIsForceUpdate] = useState(false);
	const [isInited, setIsInited] = useState(false);
	const [savedData, setSavedData] = useState(null as CustomGameDataConfig);
	const root = useRef(null);
	const [focusSet, setFocusSet] = useState(false);
	if(!isInited) {
		setTimeout(() => {
			setIsInited(true);
		}, 250);
	}

	useEffect(() => {
		props.animation.updateProps({
			page: root.current
		});
		addOnColorSchemeChangedHandler = Tools.addOnColorSchemeChanged((isDarkMode: boolean) => {
			setIsDarkTheme(isDarkMode);
		});

		return () => {
			Tools.removeOnColorSchemeChanged(addOnColorSchemeChangedHandler)
		}
	}, [root])
	

	if(!savedData) {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			setSavedData(savedData.data);
		});
		return <div ref={root}  style={{
		}}></div>;
	}
	// (window as any)['core-volume-state'] = (isEnabled: boolean) => {
	// 	props.defaultIsAudioEnabled = isEnabled;
	// 	setIsForceUpdate(!isForceUpdate);
	// }

	// (window as any)['core-cc-state'] = (isEnabled: boolean) => {
	// 	props.defaultIsCCEnabled = isEnabled;
	// 	setIsForceUpdate(!isForceUpdate);
	// }

	// (window as any)['core-motion-state'] = (isEnabled: boolean) => {
	// 	props.defaultIsMotionEnabled = isEnabled;
	// 	setIsForceUpdate(!isForceUpdate);
	// }
	(window as any)['core-motion-state-reverse'] = (isEnabled: boolean) => {
		setIsForceUpdate(!isForceUpdate);
	}
	(window as any)['core-animation-state-reverse'] = (isEnabled: boolean) => {
		setIsForceUpdate(!isForceUpdate);
	}
	if(!focusSet) {
		Tools.getSaveData().then((retrievedData: CustomGameDataManager) => {
			if(retrievedData.data.isAnimationsEnabled) {
				setTimeout(() => {
					setFocus('accessibility-window-top');
				}, 1000);
			} else {
				setFocus('accessibility-window-top', null, 250);
			}
			
			setFocusSet(true);
		})
	}
	

	const getIconTheme = () => {
		return {
			filter: isDarkTheme ? 'invert(1)' : 'unset'
		}
	}
	return (
		<div ref={root} className={"modal-disable-select center-element accessibility-window-container " + props.animation.getInitialClass()} style={{
		}}>
			<PopUp4
				title=""
				toggleButtons={[
					{
						imgSrc: accessibilityWindowCaching.getItemByKey('visibility').src,
						idFor508: 'accessibility-window-top',
						imgStyle: getIconTheme(),
						width: '80%',
						height: '80px',
						buttonText: "Visible focus",
						isSelected: false,
						defaultIsEnabled: savedData.isVisibleFocusEnabled,
						onToggled: props.onSetVisibleFocus
					},
					{
						imgSrc: accessibilityWindowCaching.getItemByKey('volume').src,
						imgStyle: getIconTheme(),
						width: '80%',
						height: '80px',
						buttonText: "Audio",
						isSelected: false,
						defaultIsEnabled: savedData.isAudioEnabled,
						onToggled: props.onSetAudio
					},
					{
						imgSrc: accessibilityWindowCaching.getItemByKey('cc').src,
						imgStyle: getIconTheme(),
						width: '80%',
						height: '80px',
						buttonText: "Closed Captions",
						isSelected: false,
						defaultIsEnabled: savedData.isClosedCaptionEnabled,
						onToggled: props.onSetCC
					},
					{
						imgSrc: accessibilityWindowCaching.getItemByKey('motion').src,
						imgStyle: getIconTheme(),
						width: '80%',
						height: '80px',
						buttonText: "Motion",
						isSelected: false,
						defaultIsEnabled: savedData.isMotionEnabled,
						onToggled: props.onSetMotion
					},
					{
						imgSrc: accessibilityWindowCaching.getItemByKey('animations').src,
						imgStyle: getIconTheme(),
						animImage: true,
						width: '80%',
						height: '80px',
						buttonText: "UI Animations",
						isSelected: false,
						defaultIsEnabled: savedData.isAnimationsEnabled,
						onToggled: props.onSetAnimations
					}
				]}
				previousMenuBttn={
					{
						imgSrc: accessibilityWindowCaching.getItemByKey('return1').src,
						width: '80%',
						height: '80px',
						buttonText: "Return to Previous Menu",
						onClick: props.onReturnToPreviousMenuClicked,
						hoverColor: constants.design.hoverColor2
					}}
				onRenderContent={() => {
					return (
						<p className='center-element-horizontal' style={{
							textAlign:'center',
							width: '100%'
						}}>
							<span className=' white-text'>Accessibility</span><br />
							<br />
							Adjust your experience below:
						</p>);
				}}></PopUp4> 
		</div>
	);

};

export interface AccessibilityWindowConfig extends BaseConfig {
	animation: AnimationPage;
	defaultIsVisibleFocusEnabled: boolean;
	defaultIsAudioEnabled: boolean;
	defaultIsCCEnabled: boolean;
	defaultIsMotionEnabled: boolean;
	defaultIsAnimationsEnabled: boolean;
	onSetVisibleFocus: (isEnabled: boolean) => void;
	onSetAudio: (isEnabled: boolean) => void;
	onSetCC: (isEnabled: boolean) => void;
	onSetMotion: (isEnabled: boolean) => void;
	onSetAnimations: (isEnabled: boolean) => void;
	onReturnToPreviousMenuClicked: () => void;
}

export default AccessibilityWindow;